import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import { CART_CONTENT_DIVIDER_THICKNESS } from '~shared/segments/Cart';
import { CART_ITEM_TOTAL_FONT_SIZE } from '~ui/components/cart/CartItemTotal';
import { defaultLineHeight, getTextFontSizeInPx } from '~ui/styleGuide/fontStyles';
import { getSpacingValueInPx } from '~ui/styleGuide/spaces';

/**
 * This hook is used to calculate the height of the cart total element.
 * It is used to compensate for the height of the stuck cart total element.
 */
export var useCartTotalHeight = function useCartTotalHeight(_ref) {
  var cartTotalPadding = _ref.cartTotalPadding,
      recalculateCartTotalHeight = _ref.recalculateCartTotalHeight;
  var cartTotalPredictedHeight = getTextFontSizeInPx(CART_ITEM_TOTAL_FONT_SIZE) * defaultLineHeight + getSpacingValueInPx(cartTotalPadding) + CART_CONTENT_DIVIDER_THICKNESS;
  var predictedInitialHeight = "".concat(cartTotalPredictedHeight, "px");
  var refStickyCartTotal = React.useRef(null);

  var _React$useState = React.useState(predictedInitialHeight),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      cartTotalHeight = _React$useState2[0],
      setCartTotalHeight = _React$useState2[1]; // set the height of the cart total element


  React.useEffect(function () {
    var timeout = setTimeout(function () {
      if (!refStickyCartTotal.current) return;
      var cartTotalClientHeight = refStickyCartTotal.current.clientHeight; // we need to subtract the bottom padding from the height because the cart content has padding too

      var height = "".concat(cartTotalClientHeight - getSpacingValueInPx(cartTotalPadding), "px");
      setCartTotalHeight(height);
    }, 0);
    return function () {
      return clearTimeout(timeout);
    };
  }, [recalculateCartTotalHeight, cartTotalPadding]);
  return {
    cartTotalHeight: cartTotalHeight,
    refStickyCartTotal: refStickyCartTotal
  };
};